import React from 'react';
import SendCodeForm from './forms/SendCodeForm';

function SendCode() {
  const [formState, setFormState] = React.useState('mobile');

  return (
    <>
      <div className="mb-7">
        <h4 className="text-lg text-primary-500 font-semibold">
          Forgot Password?
        </h4>
        <p className="text-base text-gray-400 text-opacity-75 font-light">
          {formState === 'mobile'
            ? 'Please enter your mobile number'
            : 'Please enter your email address'}
        </p>
      </div>
      <SendCodeForm onSwitchForm={setFormState} currentForm={formState} />
    </>
  );
}
SendCode.defaultProps = {};

SendCode.propTypes = {};

export default SendCode;
